import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { NewdanhmuckhachhangAction } from 'src/actions/newdanhmuckhachhang.action';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    MenuItem,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    InputLabel,
    TableCell,
} from '@material-ui/core';

import Select from 'react-select';

import { Search as SearchIcon } from 'react-feather';

import {
    CONFIRM_TYPES,
    DEFAULT_ROW_PER_PAGE,
    DEFAULT_HOMEPAGE_ROW_PER_PAGE,
    ROW_PER_PAGE_OPTIONS,
    SIM_TYPE_LIST,
    SIM_TYPE_LIST_OBJ,
    SIM_TYPE_LIST_OBJ_WITHOUT_OPERATOR,
} from 'src/utils/constants';

const CreateEditDialog = (props) => {
    const dispatch = useDispatch()
    const { items } = useSelector(state => state.permission)
    const { selected } = useSelector(state => state.newdanhmuckhachhang)
    const [doi_tuong, setDoiTuong] = useState("-99")
    const [ma, setMa] = useState("")
    const [ten, setTen] = useState("")
    const [dia_chi, setDiaChi] = useState("")
    const [sdt, setSdt] = useState("")
    const [email, setEmail] = useState("")
    const [ghi_chu, setGhiChu] = useState("")

    const danhSachLoaiSim = SIM_TYPE_LIST_OBJ_WITHOUT_OPERATOR;

    useEffect(() => {
        if (items.length > 0) {
            return;
        }
    }, [])

    useEffect(() => {
        if (props.type === 'EDIT') {
            if (selected) {
                setDoiTuong(selected.doi_tuong)
                setMa(selected.ma)
                setTen(selected.ten)
                setDiaChi(selected.dia_chi)
                setSdt(selected.sdt)
                setEmail(selected.email)
                setGhiChu(selected.ghi_chu)
            }
        }
    }, [selected])

    const onPressPositive = () => {
        if (doi_tuong === "-99") {
            alert('Vui lòng chọn đối tượng!');
            return;
        }

        if (ma === "") {
            alert('Vui lòng nhập mã!');
            return;
        }

        if (ten === "") {
            alert('Vui lòng nhập tên!');
            return;
        }

        if (props.type === 'EDIT') {
            dispatch(NewdanhmuckhachhangAction.update(selected.id, { 
                ma, 
                ten, 
                doi_tuong, 
                dia_chi,
                sdt,
                email, 
                ghi_chu,
            }))
        } else {
            dispatch(NewdanhmuckhachhangAction.create({ 
                ma, 
                ten, 
                doi_tuong, 
                dia_chi,
                sdt,
                email, 
                ghi_chu,
            }, props.creatingFromAway))
        }
        resetState();
        props.handleClose();
    }

    const resetState = () => {
        setDoiTuong("-99")
        setMa("")
        setTen("")
        setDiaChi("")
        setSdt("")
        setEmail("")
        setGhiChu("")
    }

    return (
        <Dialog open={props.open} onClose={props.handleClose}>
            <DialogTitle>{props.type === 'EDIT' ? "Cập nhật bản ghi" : "Tạo bản ghi mới"}</DialogTitle>
            <DialogContent style={{ width: 600, paddingTop: 20 }}>
                <Grid
                    container
                    spacing={3}
                >
                    <Grid
                        item
                        md={6}
                        xs={12}
                    >
                        <Select1 fullWidth variant="outlined" name="doi_tuong" value={doi_tuong || -99} onChange={(e) => setDoiTuong(e.target.value)}>
                            <MenuItem value="-99" selected>Chọn đối tượng...</MenuItem>
                            <MenuItem value="khach_hang_le">KH lẻ</MenuItem>
                            <MenuItem value="cong_tac_vien">CTV</MenuItem>
                            <MenuItem value="dai_ly">ĐL</MenuItem>
                        </Select1>
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Mã"
                            name="ma"
                            onChange={(e) => setMa(e.target.value)}
                            required
                            value={ma}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Tên"
                            name="ten"
                            onChange={(e) => setTen(e.target.value)}
                            required
                            value={ten}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Địa chỉ"
                            name="dia_chi"
                            onChange={(e) => setDiaChi(e.target.value)}
                            value={dia_chi}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Số điện thoại"
                            name="sdt"
                            onChange={(e) => setSdt(e.target.value)}
                            value={sdt}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Email"
                            name="email"
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Ghi chú"
                            name="ghi_chu"
                            onChange={(e) => setGhiChu(e.target.value)}
                            value={ghi_chu}
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose}>Huỷ</Button>
                <Button onClick={onPressPositive}>{props.type === 'EDIT' ? "Cập nhật" : "Tạo"}</Button>
            </DialogActions>
        </Dialog >
    );
}

export default CreateEditDialog;